var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "generic-link",
    {
      class: { "nav-link": !_vm.inDropdown },
      attrs: { href: "#", title: "Logout", "data-cy": "logout-link" },
      nativeOn: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.logout.apply(null, arguments)
        },
      },
    },
    [
      !_vm.inDropdown
        ? _c("login-svg-icons", { attrs: { name: "LogOutIcon" } })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { class: { "nav-label": !_vm.inDropdown } }, [
        _vm._v("\n    Logout\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }